import { Button, Form } from 'react-bootstrap'
import KButton from '../../components/KButton'
import { t } from '../../locale'

type UserSortKey = 'lastName' | 'firstName' | 'email'
type SortDir = 'asc' | 'desc'

interface Props {
  searchKeyword: string
  onSearchChange: (value: string) => void
  onShowAll: () => void
  filterAdmin: string
  onFilterAdmin: (value: string) => void
  filterConfirmed: string
  onFilterConfirmed: (value: string) => void
  sortKey: UserSortKey
  sortDir: SortDir
  onSortChange: (key: UserSortKey, dir: SortDir) => void
  onViewChange: (isTable: boolean) => void
}

function UserToolbar({
  searchKeyword,
  onSearchChange,
  onShowAll,
  filterAdmin,
  onFilterAdmin,
  filterConfirmed,
  onFilterConfirmed,
  sortKey,
  sortDir,
  onSortChange,
  onViewChange,
}: Props) {
  return (
    <div className='d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-1 pb-2 mb-3 border-bottom'>
      <input
        type='search'
        className='border border-primary rounded-pill px-2'
        placeholder={t('search') + '...'}
        aria-label='Search'
        value={searchKeyword}
        autoComplete='on'
        onChange={e => onSearchChange(e.target.value)}
      />

      <div className='btn-toolbar mb-2 mb-md-0 ms-4 flex-nowrap' style={{ gap: '8px' }}>
        {/* ALL */}
        <Button
          type='button'
          className='text-white rounded btn-primary'
          style={{ whiteSpace: 'nowrap' }}
          onClick={onShowAll}
        >
          {t('all')}
        </Button>

        {/* ADMIN FILTERS */}
        <KButton
          variant={filterAdmin === 'true' ? 'primary' : 'secondary'}
          type='button'
          icon='shield-fill-check'
          className='text-white ms-3'
          title={t('admin')}
          onClick={() => onFilterAdmin(filterAdmin === 'true' ? '' : 'true')}
        />
        <KButton
          variant={filterAdmin === 'false' ? 'primary' : 'secondary'}
          type='button'
          icon='person-fill'
          className='text-white'
          title={t('nonAdmin')}
          onClick={() => onFilterAdmin(filterAdmin === 'false' ? '' : 'false')}
        />

        {/* CONFIRMED FILTERS */}
        <KButton
          variant={filterConfirmed === 'true' ? 'success' : 'secondary'}
          type='button'
          icon='check-circle-fill'
          className='text-white ms-3'
          title={t('confirmed')}
          onClick={() => onFilterConfirmed(filterConfirmed === 'true' ? '' : 'true')}
        />
        <KButton
          variant={filterConfirmed === 'false' ? 'danger' : 'secondary'}
          type='button'
          icon='x-circle-fill'
          className='text-white'
          title={t('unconfirmed')}
          onClick={() => onFilterConfirmed(filterConfirmed === 'false' ? '' : 'false')}
        />

        {/* SORT */}
        <Form.Select
          value={`${sortKey}:${sortDir}`}
          onChange={(e: any) => {
            const [k, d] = e.target.value.split(':') as [UserSortKey, SortDir]
            onSortChange(k, d)
          }}
          className='ms-3 text-decoration-none'
          style={{ width: 'auto', textTransform: 'none' }}
        >
          <option value='lastName:asc'>{t('sortByLastName')} (A–Z)</option>
          <option value='lastName:desc'>{t('sortByLastName')} (Z–A)</option>
          <option value='firstName:asc'>{t('sortByFirstName')} (A–Z)</option>
          <option value='firstName:desc'>{t('sortByFirstName')} (Z–A)</option>
          <option value='email:asc'>{t('sortByEmail')} (A–Z)</option>
          <option value='email:desc'>{t('sortByEmail')} (Z–A)</option>
        </Form.Select>

        {/* VIEW */}
        <Button variant='none' className='btn-sm' onClick={() => onViewChange(false)}>
          <i className='bi bi-list-ul'></i>
        </Button>
        <Button variant='none' className='btn-sm' onClick={() => onViewChange(true)}>
          <i className='bi bi-grid'></i>
        </Button>
      </div>
    </div>
  )
}

export default UserToolbar
